'use client';

import React, { useCallback } from 'react';
import { Row, Button, DataLayer } from '@stape-io/promo-shared-content/components';
import clsx from 'clsx';

import SupportIcon from '@/icons/svg/hand-support.svg';
import { useClientTranslation } from '@/lib/i18n/client';
import { contactContactSupportUrl } from '@/lib/constants/Links';

import styles from './ContactSupportSection.module.scss';

export function ContactSupportSection({ main = false }: { main?: boolean }) {
  const { t } = useClientTranslation();
  const handlerOnClick = useCallback(() => {
    DataLayer.pushSupportHelpdeskClickEvent('banner_contact_support');
    window.open(contactContactSupportUrl, '_blank');
  }, []);
  return (
    <Row alignCenter className={clsx(styles.wrapper, { [styles.mainRow]: main })}>
      <div className={styles.supportLayout}>
        <Row className={styles.wrapperContent}>
          <div className={styles.contentWrapper}>
            <div className={styles.iconContainer}>
              <SupportIcon />
            </div>
            <span className={clsx(styles.text, 'h3')}>{t('contact.supportTitle')}</span>
            <Button onClick={handlerOnClick} className={clsx(styles.button, 'text text-sm text-bold')}>
              {t('contact.support')}
            </Button>
          </div>
        </Row>
      </div>
    </Row>
  );
}
